
import React, { useState, useRef, useEffect } from 'react';
import { MessageSquare, Send, X, Bot, Zap } from 'lucide-react';
import { getFinancialAdvice } from '../services/geminiService';
import { Message } from '../types';

const AIChat: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState<Message[]>([
    { role: 'model', text: '¡Hola! Soy tu mentor del Underground Playbook. ¿En qué paso del sistema PQR2 o de los 6 pasos quieres profundizar hoy?' }
  ]);
  const [input, setInput] = useState('');
  const [isTyping, setIsTyping] = useState(false);
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]);

  const handleSend = async () => {
    if (!input.trim()) return;
    const userMsg = input.trim();
    setInput('');
    setMessages(prev => [...prev, { role: 'user', text: userMsg }]);
    setIsTyping(true);
    const aiResponse = await getFinancialAdvice(userMsg);
    setMessages(prev => [...prev, { role: 'model', text: aiResponse }]);
    setIsTyping(false);
  };

  return (
    <div className="fixed bottom-8 right-8 z-50">
      {!isOpen ? (
        <button 
          onClick={() => setIsOpen(true)}
          className="bg-yellow-500 text-slate-900 p-5 rounded-2xl shadow-2xl hover:scale-110 transition-all flex items-center justify-center border-2 border-yellow-400"
        >
          <Zap className="w-7 h-7 fill-slate-900" />
        </button>
      ) : (
        <div className="bg-[#0F0F30] w-[380px] h-[550px] rounded-[2.5rem] shadow-2xl flex flex-col border border-white/10 overflow-hidden">
          <div className="bg-[#1A1A4A] p-6 flex justify-between items-center border-b border-white/5">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-yellow-500 rounded-xl flex items-center justify-center">
                <Bot className="w-6 h-6 text-slate-900" />
              </div>
              <div>
                <h3 className="text-white font-black text-sm uppercase tracking-tighter italic">Mentor Secrets</h3>
                <span className="text-yellow-500 text-[10px] font-bold uppercase tracking-widest">En Línea</span>
              </div>
            </div>
            <button onClick={() => setIsOpen(false)} className="text-slate-400 hover:text-white transition-colors">
              <X className="w-6 h-6" />
            </button>
          </div>

          <div ref={scrollRef} className="flex-1 overflow-y-auto p-6 space-y-6 bg-[#050517]/80">
            {messages.map((msg, i) => (
              <div key={i} className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}>
                <div className={`max-w-[85%] p-4 rounded-2xl text-sm leading-relaxed ${
                  msg.role === 'user' 
                  ? 'bg-yellow-500 text-slate-900 font-bold rounded-tr-none shadow-lg' 
                  : 'bg-[#1A1A4A] text-slate-200 border border-white/5 rounded-tl-none'
                }`}>
                  {msg.text}
                </div>
              </div>
            ))}
            {isTyping && (
              <div className="flex justify-start">
                <div className="bg-[#1A1A4A] p-4 rounded-2xl flex space-x-1 border border-white/5">
                  <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full animate-bounce"></div>
                  <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full animate-bounce [animation-delay:0.2s]"></div>
                  <div className="w-1.5 h-1.5 bg-yellow-500 rounded-full animate-bounce [animation-delay:0.4s]"></div>
                </div>
              </div>
            )}
          </div>

          <div className="p-6 bg-[#0F0F30] border-t border-white/5 flex space-x-3">
            <input 
              type="text" 
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSend()}
              placeholder="Pregunta sobre el método..."
              className="flex-1 bg-[#050517] text-white px-5 py-3 rounded-xl text-sm outline-none border border-white/10 focus:border-yellow-500 transition-all"
            />
            <button 
              onClick={handleSend}
              className="bg-yellow-500 text-slate-900 p-3 rounded-xl hover:bg-yellow-600 transition-colors"
            >
              <Send className="w-5 h-5" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AIChat;
